export default "__VITE_ASSET__JLQ0BVXg__"